import angular from 'angular';
import SettingsGameDevEdit from './settingsGameDevEdit';
import SettingsUserEdit from './settingsUserEdit';
import template from './settings.jade';

export class AccountSettingsController {
  /* @ngInject */
  constructor(currentUser) {
    currentUser.subscribe((user) => {
      this.user = user;
    });
  }
}

export function AccountSettingsComponent() {
  return {
    template,
    controller: AccountSettingsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.account.settings', [
  SettingsGameDevEdit.name,
  SettingsUserEdit.name
])
.directive('accountSettings', AccountSettingsComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/settings/settings.js
 **/